import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import Login from '@/views/Login.vue';
import PasswordReset from '@/views/PasswordReset.vue';

import CitizenOnboardingForm from '@/features/citizenOnboarding/CitizenOnboardingForm.vue';

import Home from '@/views/Home.vue';
import Offers from '@/views/Offers.vue';

import IdentificationApplicationForm from '@/features/applications/identification/IdentificationApplicationForm.vue';
import GeorgiaDfcsBenefitsApplicationForm from '@/features/applications/georgiaDfcsBenefits/GeorgiaDfcsBenefitsApplicationForm.vue';

const routes: Array<RouteRecordRaw> = [
  { path: '/login', name: 'Login', component: Login },
  { path: '/passwordReset', name: 'PasswordReset', component: PasswordReset },

  { path: '/join/:inviteId', name: 'Citizen Onboarding', component: CitizenOnboardingForm, props: true },

  { path: '/',    name: 'Home', component: Home },
  { path: '/offers', name: 'Offers', component: Offers },

  { path: '/applications/identification', name: 'Identification Application', component: IdentificationApplicationForm },
  { path: '/applications/georgiaDfcsBenefits', name: 'Georgia DFCS Benefits Application', component: GeorgiaDfcsBenefitsApplicationForm },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
